import { As, Icon, Link, LinkProps } from '@chakra-ui/react'
import React, { useState } from 'react'

interface ContextualLinkProps extends LinkProps {
  icon?: As
  to?: string
}

const ContextualLink = ({
  children,
  icon,
  ...baseProps
}: ContextualLinkProps) => {
  const [isLinkIconVisible, setLinkIconVisible] = useState(false)
  const visibility = isLinkIconVisible ? 'visible' : 'hidden'

  return (
    <Link
      {...baseProps}
      color="apex.link"
      onBlur={() => setLinkIconVisible(false)}
      onFocus={() => setLinkIconVisible(true)}
      onMouseOut={() => setLinkIconVisible(false)}
      onMouseOver={() => setLinkIconVisible(true)}
    >
      {children}
      {icon && (
        <Icon
          as={icon}
          color={'apex.link'}
          marginLeft="4px"
          marginBottom="4px"
          visibility={visibility}
        />
      )}
    </Link>
  )
}

export default ContextualLink
